import { formatDollars } from "~frontend/util/formatDollars";

export function maybeNumberToPercentage(
  n: number | null | undefined,
  decimalDigits: number = 2
): string | null {
  if (n === null || n === undefined) {
    return null;
  }

  return `${(n * 100).toLocaleString(undefined, { minimumFractionDigits: decimalDigits, maximumFractionDigits: decimalDigits })}%`;
}

export function maybeNumberToDollars(
  n: number | null | undefined,
  decimalDigits: number = 2
): string | null {
  if (n === null || n === undefined) {
    return null;
  }

  return formatDollars(n, decimalDigits);
}
